import Vue from 'vue';
import App from './App.vue';
import store from "./store";
import Echarts from 'echarts';
import {
	Input,
	Modal,
	message,
	// Carousel, CarouselItem
} from "ant-design-vue";
import VueECharts from 'vue-echarts';
import router from './router'
import "@/style/index.scss"; 
 

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import httpServer from "./server/httpServer"; 
import config from './config/config';
import api from "@/api/api.js"

import tools from "./utils/tools"

import './static/css/common.scss'; 
import './permission'
Vue.use(Modal)
Vue.use(ElementUI); 
// 注册全局组件
Vue.prototype.$message = message
Vue.prototype.Ajax = httpServer
Vue.component('Input', Input)
Vue.component('v-chart', VueECharts);
// Vue.component('a-carousel', Carousel);
// Vue.component('a-carousel-item', CarouselItem);

Vue.config.productionTip = false;
Vue.config.productionTip = false
Vue.prototype.config = config
Vue.prototype.$api = api; // 接口
Vue.prototype.$tools = tools;  

new Vue({
	store,
	router,
	render: h => h(App),
}).$mount('#app')
